"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Inc. and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe Inc.
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Inc.
 */
var _default = {
  mock: {
    INVITATIONS_SERVICE_ENDPOINT: '/api/{VERSION}'
  },
  prod: {
    INVITATIONS_SERVICE_ENDPOINT: 'https://invitations.adobe.io/api/{VERSION}'
  },
  stage: {
    INVITATIONS_SERVICE_ENDPOINT: 'https://invitations-stage.adobe.io/api/{VERSION}'
  }
};
exports["default"] = _default;